import ReactContentLoader from "react-content-loader";

const DefaultContentLoader = (props) => (
  <rect
    x="0"
    y="0"
    rx="4"
    ry="4"
    width={props.width}
    height={props.height}
  />
);

const contentLoaderStyles = {
  width: "100%",
};

const defaultProps = {
  width: "100%",
  height: "100%",
};

export default function ContentLoaderContainer(props) {
  const {
    width,
    height,
    children,
  } = { ...defaultProps, ...props };

  return (
    <ReactContentLoader
      speed="2"
      gradientRatio="1.5"
      interval="0"
      width={width}
      height={height}
      backgroundColor="#EBEBEB"
      foregroundColor="#DADADA"
      style={contentLoaderStyles}
    >
      {children || (
        <DefaultContentLoader
          width={width}
          height={height}
        />
      )}
    </ReactContentLoader>
  );
}
